export default "__VITE_ASSET__244bca89__"